import React, { useEffect, useState } from 'react';
import { AssetAnalysisTablet } from '../../AssetDetailsMobileComponent/AssetStatusForms/Tablet/AssetAnalysisTablet';
import { AssetAnalysisMobileForm } from '../../AssetDetailsMobileComponent/AssetStatusForms/Mobile/AssetAnalysisMobileForm';

type AuxProperty = {
    aux1: {
        label: string;
        index: string;
        value: string;
        checked: boolean;
    };
    aux2: {
        label: string;
        index: string;
        value: string;
        checked: boolean;
    };
    aux3: {
        label: string;
        index: string;
        value: string;
        checked: boolean;
    };
    mode: {
        label: string;
        index: string;
        value: string;
        checked: boolean;
    };
    unit: {
        label: string;
        index: string;
        value: string;
        checked: boolean;
    };
}

interface AssetAnalysisProps {
    customerId: string,
    assetId: string,
    userTimeZone: string,
    assetName: string,
    handleLogout: () => void,
    startTime?: string,
    currentTab?: number,
    endTime?: string,
    auxProperties: AuxProperty,
    isIntermittentMode?: boolean,
    isBasicWellMethod: boolean
}

export const AssetAnalysisForm: React.FC<AssetAnalysisProps> = ({ assetName, assetId, customerId, userTimeZone, handleLogout, startTime, currentTab, endTime, auxProperties,isIntermittentMode, isBasicWellMethod }) => {

    const [isMobile, setIsMobile] = useState(window.innerWidth < 620); // Assuming width less than 768px is considered mobile  

    useEffect(() => {
        let timeoutId;

        const handleResize = () => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                setIsMobile(window.innerWidth < 620); // Update state based on window width
            }, 100); // Adjust the debounce interval as needed
        };
        handleResize(); // Initial call to set initial state
        window.addEventListener('resize', handleResize); // Add event listener for window resize

        return () => {
            window.removeEventListener('resize', handleResize); // Remove event listener on component unmount
        };
    }, [window.innerWidth]); // Empty dependency array to run effect only once

    return (

        isMobile ? <AssetAnalysisMobileForm assetName={assetName} assetId={assetId} customerId={customerId} userTimeZone={userTimeZone} handleLogout={handleLogout} currentTab={currentTab} startTime={startTime} endTime={endTime} auxProperties={auxProperties} isIntermittentMode = {isIntermittentMode} isBasicWellMethod = {isBasicWellMethod} /> : <AssetAnalysisTablet assetName={assetName} assetId={assetId} customerId={customerId} userTimeZone={userTimeZone} handleLogout={handleLogout} currentTab={currentTab} startTime={startTime} endTime={endTime} auxProperties={auxProperties} isIntermittentMode = {isIntermittentMode} isBasicWellMethod = {isBasicWellMethod}/>

    );
};
